import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Legacy fallback: attach Bearer token for sessions created before the httpOnly-cookie migration.
  // New sessions authenticate via the httpOnly `session_token` cookie (sent automatically).
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    // Handle subscription expired/inactive/past_due
    if (error.response?.status === 403) {
      const subscriptionStatus = error.response.headers?.["x-subscription-status"];
      if (["expired", "inactive", "required", "past_due", "suspended", "canceled"].includes(subscriptionStatus)) {
        localStorage.setItem("subscription_error", error.response.data?.detail || "Subscription required");
        localStorage.setItem("subscription_status", subscriptionStatus);
        window.location.href = "/subscription-required";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
